import React, { useState } from 'react';
import { useScrollAnimation } from '../hooks/useScrollAnimation';
import { Plus, X } from 'lucide-react';
const faqs = [{
  q: '¿Necesito saber de tecnología para usar este sistema?',
  a: 'No. Si sabés enviar un mensaje de WhatsApp, podés usar este sistema. Está diseñado paso a paso para docentes sin experiencia técnica.'
}, {
  q: '¿Funciona para mi materia y nivel?',
  a: 'Sí. El sistema es universal. Funciona para Inicial, Primaria y Secundaria, en cualquier materia. Eso es exactamente lo que lo diferencia de los packs específicos por materia.'
}, {
  q: '¿La IA reemplaza mi criterio como docente?',
  a: 'Para nada. La IA es tu herramienta. Vos seguís siendo el profesional. El sistema te ayuda a hacer más en menos tiempo, sin perder la calidad pedagógica.'
}, {
  q: '¿Cuánto tiempo tarda en verse resultados?',
  a: 'La mayoría de los docentes ahorran tiempo desde la primera semana de uso.'
}, {
  q: '¿Cómo accedo al material?',
  a: 'Inmediatamente después del pago recibís un email con el acceso completo al manual y todos los bonuses. No hay esperas.'
}, {
  q: '¿Y si no me sirve?',
  a: 'Tenés 7 días de garantía total. Si no estás satisfecha, te devolvemos el 100% sin preguntas.'
}];
export function FAQSection() {
  const {
    ref,
    isVisible
  } = useScrollAnimation();
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  const toggleFaq = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };
  return <section className="w-full bg-offwhite py-24 px-4 sm:px-6 lg:px-8" data-id="element-13">
      <div ref={ref} className={`max-w-[800px] mx-auto transition-all duration-1000 transform ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'}`} data-id="element-14">
        <div className="text-center mb-16" data-id="element-15">
          <span className="inline-block font-montserrat font-bold text-gold text-sm tracking-widest uppercase mb-4" data-id="element-16">
            PREGUNTAS FRECUENTES
          </span>
        </div>

        <div className="space-y-4" data-id="element-17">
          {faqs.map((faq, index) => {
          const isOpen = openIndex === index;
          return <div key={index} className="bg-white rounded-xl shadow-sm border border-gray-100 overflow-hidden transition-all duration-300" data-id="element-18">
                <button onClick={() => toggleFaq(index)} className="w-full flex items-center justify-between p-6 text-left focus:outline-none" data-id="element-19">
                  <span className="font-inter font-bold text-[17px] text-navy pr-8" data-id="element-20">
                    {faq.q}
                  </span>
                  <div className={`flex-shrink-0 w-8 h-8 rounded-full flex items-center justify-center transition-colors duration-300 ${isOpen ? 'bg-gold text-navy' : 'bg-gray-50 text-gold'}`} data-id="element-21">
                    {isOpen ? <X size={18} data-id="element-22" /> : <Plus size={18} data-id="element-23" />}
                  </div>
                </button>

                <div className={`px-6 overflow-hidden transition-all duration-300 ease-in-out ${isOpen ? 'max-h-48 pb-6 opacity-100' : 'max-h-0 opacity-0'}`} data-id="element-24">
                  <p className="font-inter text-[16px] text-gray-600 leading-relaxed border-t border-gray-50 pt-4" data-id="element-25">
                    {faq.a}
                  </p>
                </div>
              </div>;
        })}
        </div>
      </div>
    </section>;
}